import React from 'react';
import PropTypes from 'prop-types';

import './table-body.scss';

export class TableBody extends React.PureComponent {
  static propTypes = {
    data: PropTypes.array,
    config: PropTypes.object.isRequired,
  };

  static defaultProps = {
    data: [],
  };

  renderRow = (item, index, config) => {
    const {
      columnsConfig = [],
      trClassName = '',
      trClickCallback = () => {},
    } = config;

    return (
      <tr
        className={`tr ${trClassName}`}
        onClick={() => trClickCallback(item)}
        key={index}
      >
        {columnsConfig.map((configItem, index) => {
          if (!(configItem.name in item)) {
            return (
              <td
                key={index}
                className={`tr__td word-break ${configItem.tdClass || ''}`}
              />
            );
          }
          return (
            <td
              key={index}
              className={`tr__td word-break ${configItem.tdClass || ''}`}
            >
              {item[configItem.name]}
            </td>
          );
        })}
      </tr>
    );
  };

  render() {
    const { data, config } = this.props;

    return (
      <tbody className="table-body">
        {data.map((item, index) => this.renderRow(item, index, config))}
      </tbody>
    );
  }
}
